import dimensions from 'shared/styles/dimensions'
import styled from 'styled-components'

import Button from '../../../../../../shared/components/Button'

export const ContainerForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 916px;

  input {
    width: 448px;
    margin: ${dimensions.spaces.small}px 0;
    &:nth-child(3) {
      width: 208px;
    }
    &:nth-child(4) {
      width: 219px;
    }
  }

  @media (max-height: 668px) {
    margin-top: -35px;
  }
`

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 1377px) {
    position: absolute;
    bottom: -17px;
  }

  @media (max-height: 668px) {
    bottom: 33px;
  }
`
